import { computed } from 'vue';
import { gql } from '@apollo/client/core';
import { useQuery } from '@vue/apollo-composable';
import { Query } from '@spectee/graphql/api';
import { getInvitationBasicDetailsWithoutOrgId } from '@spectee/graphql/queries';

const document = gql(getInvitationBasicDetailsWithoutOrgId);

type QueryResult = {
  getInvitationBasicDetailsWithoutOrgId: Query['getInvitationBasicDetailsWithoutOrgId'];
};
export function useGetInvitationBasicDetailsWithoutOrgId() {
  const API = useQuery<QueryResult>(document);

  const getInvitationBasicDetailsRes = computed(
    () => API.result.value?.getInvitationBasicDetailsWithoutOrgId
  );
  return {
    ...API,
    getInvitationBasicDetailsRes,
  };
}
